import VueRouter from "vue-router";

// Commit the running bundle was built from; empty for local builds
const CURRENT_VERSION = process.env.VUE_APP_VERSION;
const MIN_CHECK_INTERVAL_MS = 60 * 1000;
// Remembers which version we already reloaded for, so a stale response can't cause a reload loop
const RELOADED_FOR_KEY = "reloadedForVersion";

let deployedVersion: string | undefined;
let lastCheck = 0;

async function checkForNewVersion(): Promise<void> {
  if (Date.now() - lastCheck < MIN_CHECK_INTERVAL_MS) {
    return;
  }
  lastCheck = Date.now();

  try {
    const response = await fetch(`/version.json?t=${lastCheck}`, { cache: "no-store" });
    const { version } = await response.json();
    if (version) {
      deployedVersion = version;
    }
  } catch (e) {
    // Offline or no version.json (CloudFront then answers with index.html), try again later
  }
}

function isNewVersionAvailable(): boolean {
  if (!deployedVersion || deployedVersion === CURRENT_VERSION) {
    return false;
  }
  try {
    return sessionStorage.getItem(RELOADED_FOR_KEY) !== deployedVersion;
  } catch (e) {
    return true;
  }
}

/**
 * Loads a newly deployed version of the app. Phones keep the app open for days without reloading it, so we check for
 * a new version whenever the app comes back to the foreground, and reload on the next navigation. Reloading only
 * on navigation means nobody loses what they are typing in a form.
 */
export function installVersionCheck(router: VueRouter): void {
  if (!CURRENT_VERSION) {
    return;
  }

  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") {
      checkForNewVersion();
    }
  });

  router.beforeEach((to, from, next) => {
    if (isNewVersionAvailable()) {
      try {
        sessionStorage.setItem(RELOADED_FOR_KEY, deployedVersion as string);
      } catch (e) {
        // Without sessionStorage we can't guard against a loop, reload anyway
      }
      window.location.assign(router.resolve(to.fullPath).href);
      next(false);
    } else {
      checkForNewVersion();
      next();
    }
  });
}
